import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser, resetLoginFlag, loginError } from "../../store/actions"
import { userConstants } from "constants/user"
import { toast } from "react-toastify"

const Login = props => {
  const dispatch = useDispatch()
  const [modelLogin, setModelLogin] = useState({
    email: "",
    password: "",
  })

  const { error, loading } = useSelector(state => ({
    error: state.Login.error,
    loading: state.Login.loading,
  }))

  useEffect(() => {
    const isInvalidToken = localStorage.getItem(userConstants.STORAGE.IS_INVALID_TOKEN)
    if (isInvalidToken && JSON.parse(isInvalidToken) === true) {
      toast.error(<div>{"Session is expired !"}<br/>{"Please log in again."}</div>)
      localStorage.removeItem(userConstants.STORAGE.IS_INVALID_TOKEN)
    }
  }, [])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(resetLoginFlag())
      }, 5000)
    }
  }, [error])

  const handleValidSubmit = (event, values) => {
    if (!modelLogin.email.trim()) {
      dispatch(loginError("email is required !"))
      return
    }

    if (!modelLogin.password.trim()) {
      dispatch(loginError("password is required !"))
      return
    }

    dispatch(
      loginUser(
        {
          email: modelLogin.email.trim(),
          password: modelLogin.password.trim(),
        },
        props.history
      )
    )
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Hast | Login</title>
      </MetaTags>
      <div
        className="account-pages"
        style={{
          width: "100%",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <span className="logo-sm">
              {/* <img src={logoLightSvg} alt="" height="22" /> */}
              <h1
                style={{
                  color: "Black",
                  textAlign: "center",
                }}
              >
                HAST
              </h1>
              <h5 className="text-center mb-4">Tracking System</h5>
            </span>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-3">
                        <AvField
                          name="login_email"
                          label="Email"
                          value={modelLogin.email || ""}
                          className="form-control"
                          placeholder="Enter email"
                          type="text"
                          onChange={e =>
                            setModelLogin({
                              ...modelLogin,
                              email: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="login_password"
                          label="Password"
                          value={modelLogin.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={e =>
                            setModelLogin({
                              ...modelLogin,
                              password: e.target.value,
                            })
                          }
                        />
                      </div>
                      {/* 
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div> */}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          Login
                        </button>
                      </div>
                      {/* 
                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div> */}
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* <Footer /> */}
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
